import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState({
        name: localStorage.getItem("name") || "",
        isAuthenticated: !!localStorage.getItem("access_token"),
    });

    const login = (name, accessToken, refreshToken) => {
        localStorage.setItem("access_token", accessToken);
        localStorage.setItem("refresh_token", refreshToken);
        localStorage.setItem("name", name);

        setUser({
            name,
            isAuthenticated: true,
        });
    };

    const logout = () => {
        localStorage.clear();
        setUser({
            name: "",
            isAuthenticated: false,
        });
    };

    const setName = (name) => {
        setUser({
            name,
            isAuthenticated: true,
        });
        localStorage.setItem("name", name);
    };

    useEffect(() => {
        setUser({
            name: localStorage.getItem("name") || "",
            isAuthenticated: !!localStorage.getItem("access_token"),
        });
    }, []);

    return (
        <AuthContext.Provider value={{ user, login, logout, setName }}>
            {children}
        </AuthContext.Provider>
    );
};
